import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonCardFooter } from 'src/app/shared/components/card-footer/models/alcmeon-card-footer.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { ExternalAuthorizationsService } from '../external-authorizations.service';
import { ExternalAuthorization } from '../shared/external-authorization.model';

@Component({
  selector: 'app-external-authorization',
  templateUrl: './external-authorization.component.html',
  styleUrls: ['./external-authorization.component.scss'],
})
export class ExternalAuthorizationComponent implements OnInit {
  get headersArray() {
    return this.form?.get('headers') as FormArray;
  }

  externalAuthorization: ExternalAuthorization;
  form: FormGroup = this.formBuilder.group({
    id: [null],
    name: [null, Validators.required],
    clientId: [null, Validators.required],
    secret: [null],
    endpoint: [null, Validators.required],
    scope: [null, Validators.required],
    headers: this.formBuilder.array([]),
  });
  footerContent: AlcmeonCardFooter;

  create: boolean;
  backToLabel = this.basicService.translate('parameters/external-authorizations/details/back');

  constructor(
    public externalAuthorizationsService: ExternalAuthorizationsService,
    private basicService: BasicService,
    private formBuilder: FormBuilder,
    private customRouter: CustomRouter,
    @Inject('$stateParams') private $stateParams: { externalAuthorizationId: number }
  ) {
    this.create = customRouter.current?.data?.create;
  }

  ngOnInit(): void {
    if (!this.create) {
      this.getExternalAuthorization(this.$stateParams.externalAuthorizationId);
    } else {
      this.form.get('secret').addValidators(Validators.required);
      this.addHeader();
    }
  }

  goBack() {
    this.customRouter.go('auth.alcmeon.fuse.parameters.external-authorizations.list');
  }

  private getExternalAuthorization(externalAuthorizationId) {
    this.basicService.showSpinner();
    this.externalAuthorizationsService
      .getExternalAuthorization(externalAuthorizationId)
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe({
        next: (externalAuthorization: ExternalAuthorization) => {
          const { id, client_id, endpoint, scope, headers, name, createdByLabel, creation_time } =
            externalAuthorization;
          Array.from({ length: Math.max(headers.length, 1) }).forEach(() => this.addHeader());

          this.form.patchValue({
            id,
            name,
            clientId: client_id,
            endpoint,
            scope,
            headers,
          });
          this.externalAuthorization = externalAuthorization;

          this.footerContent = {
            createdBy: createdByLabel,
            createdAt: creation_time,
          };
        },
      });
  }

  save() {
    this.basicService.showSpinner();
    this.externalAuthorizationsService
      .saveExternalAuthorization(this.form.getRawValue())
      .pipe(finalize(() => this.basicService.hideSpinner()))
      .subscribe({
        next: () => {
          this.basicService.toastSuccess('parameters/external-authorizations/details/saved');
          this.goBack();
        },
      });
  }

  addHeader() {
    this.headersArray.push(
      this.formBuilder.group({
        name: ['', Validators.required],
        value: ['', Validators.required],
      })
    );
  }

  deleteHeader(index: number) {
    this.headersArray.removeAt(index);
  }
}
